const $ = require('jquery');

// eslint-disable-next-line jsdoc/require-returns-check
/**
 * A function that builds each widget received from optimizely in the smartRecs callback
 *
 * @param {Object} widgetObject - The widget object received from the smartRecs callback
 * @returns {Promise} A Promise that will return the widget's html once resolved.
 */
function buildWidget(widgetObject) {
    // makes the call to the back end to get the correct
    // template rendered for the widget
    const {position, recs, widget} = widgetObject;
    if (recs && recs.length) {
        // Reduce the size of the array since we won't use more than 12 products in any scnenarios
        const slicedRecommendationsArray = recs.slice(0, 21);
        const renderWidgetUrl = $('.js-optimizely-data').data('widget-request-url');
        const data = {
            slicedRecommendationsArray,
            position,
            widget
        };

        return $.ajax({
            type: 'POST',
            url: renderWidgetUrl,
            data: {
                JSONData: JSON.stringify(data)
            }
        }).then(result => {
            if (result && Object.keys(result).length) {
                const {widgetPlaceholder, renderedWidget} = result;
                const placeholder = $(widgetPlaceholder);
                placeholder.html(renderedWidget);
                if (placeholder.length) {
                    sendAjaxImpressionTracking(widgetObject);
                }
            }
        });
    }
}

/**
 * Renders the widgets received in the SmartRecs callback
 *
 * @param {Event} event - The JavaScript event with the widgets array
 * @returns {void}
 */
function renderWidget(event) {
    // replaces whatever result we get from buildWidget on the html and inits the carousel
    const widgets = event.detail;
    if (widgets && widgets.length) {
        widgets.forEach(function (widget) {
            buildWidget(widget);
        });
    }
}

/**
 * Function that sends the impressions track AJAX event
 *
 * @param {Array} widgetData - The data related to the widget to be tracked
 * @returns {void}
 */
function sendAjaxImpressionTracking(widgetData) {
    if (window.Peerius) {
        const recommendationIds = String(widgetData.recs.map(item => item.id));
        const optimizelyImpressionTrackingUrl = $('.js-optimizely-impression-tracking-url').data(
            'optimizely-impression-tracking-url'
        );
        window.Peerius.sendAjax(optimizelyImpressionTrackingUrl + recommendationIds);
    }
}

/**
 * Function that sends SmartRecs click event
 *
 * @param {Event} e - The JavaScript click event
 * @returns {void}
 */
function smartRecsClickEvent(e) {
    e.preventDefault();
    const $listItem = $(e.currentTarget);
    const relatedRecommendationId = $listItem.data('recommendation-id');
    if (window.Peerius) {
        window.Peerius.smartRecsClick(relatedRecommendationId);
    }
    const productUrl = $listItem.find('a')[0].href;
    window.location.href = productUrl;
}

/**
 * Function that initializes the widget builder
 */
function init() {
    /**
     * No event emitters will exist if the feature is not enabled in the site.
     * Thus, adding the event listener will not lead to any crashes.
     */
    document.addEventListener('optimizely:renderWidget', renderWidget);
    $(document).on('click', '.js-optimizely-tile', smartRecsClickEvent);
}

module.exports.init = init;
